import { newOperations } from "./new-operations";
import { inventory } from "./inventory";

import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    inventory: {
      namespaced: true,
      ...inventory,
    },
    newOperations: {
      namespaced: true,
      ...newOperations,
    },
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/stock/store/index.js